import React, { memo } from 'react';
import styles from './iconButton.module.scss';
import { CircularProgress } from '@mui/material';

const iconButton = ({ className, onClick, children, loading = false }) => {

    const handleOnEnter = (ev) => {
        if (ev.charCode === 13) {
            if (typeof onClick === "function") {
                onClick();
            }
        }
    }

    return (
        !loading
            ? <div onKeyPress={handleOnEnter} className={`${className} ${styles.content}`} tabIndex="0">
                < button className={` ${styles.button}`} onClick={onClick} >
                    {children}
                </button >
            </div>
            : <div className={`${className} ${styles.content} `}>
                < button className={`${styles.button} ${styles.loading} `}>
                    <CircularProgress className={styles.loader} />
                </button >
            </div>

    );

}

export default memo(iconButton);